import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-person-add-sharp",
  "use": "icon-person-add-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-person-add-sharp\"><title>Person Add</title><path d=\"M106 304v-54h54v-36h-54v-54H70v54H16v36h54v54h36z\" /><circle cx=\"288\" cy=\"144\" r=\"112\" /><path d=\"M288 288c-69.42 0-208 42.88-208 128v64h416v-64c0-85.12-138.58-128-208-128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol